import $ from 'jquery';

const onClickTooltipToggle = function(e) {
	e.preventDefault();
	e.stopPropagation();
	$(e.target).closest('.tooltip-wrapper').children('.tooltip').toggle();
};

$('.app').on('click', '.tooltip-toggle', onClickTooltipToggle);
